import { ParsedUrlQuery } from 'querystring';
import { IFacet, IFacetValue } from '~/lib/data-contract';

/**
 * Mutates provided object to add/remove the correct id for the selected facet
 * Can be optimized for better cache use if the facets ids and values were sorted so the order it was applied didn't matter
 *
 * @param routerQuery record with queries (e.g. router.query)
 * @param facetId id from IFacet (e.g. 'color-id')
 * @param facetValueId id from IFacetValue (e.g. '11670')
 */
export const toggleFacetQuery = (routerQuery: Record<string, ParsedUrlQuery[0]>, facetId: IFacet['id'], facetValueId: IFacetValue['id']) => {
	const currentValue = routerQuery[facetId];
	if (typeof currentValue === 'undefined') {
		// It is not enabled
		routerQuery[facetId] = facetValueId;
	} else if (typeof currentValue === 'string') {
		const isEnabled = currentValue === facetValueId;
		if (isEnabled) {
			delete routerQuery[facetId];
		} else {
			routerQuery[facetId] = [currentValue, facetValueId];
		}
	} else {
		const isEnabled = currentValue.includes(facetValueId);
		if (isEnabled) {
			const newValue = currentValue.filter((val) => val !== facetValueId);
			if (newValue.length === 0) {
				delete routerQuery[facetId];
			} else if (newValue.length === 1) {
				routerQuery[facetId] = newValue[0];
			} else {
				routerQuery[facetId] = newValue;
			}
		} else {
			routerQuery[facetId] = currentValue.concat(facetValueId);
		}
	}
};
